export default "__VITE_ASSET__IaIpjrei__"